// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__26OYQ","colCheckbox":"styles_colCheckbox__3q_oZ"};